// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../../../../../../node_modules/@rsbuild/core/compiled/css-loader/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../../../../../node_modules/@rsbuild/core/compiled/css-loader/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.wjMCTTpJSakcsrOBJI1u{display:inline-block}.wjMCTTpJSakcsrOBJI1u .qSRk8CLXNRM8Xt3qCdWF{padding-right:24px}.wjMCTTpJSakcsrOBJI1u .ECPTxTYb0sMR6umYC8_b{color:var(--content-primary-primary-inverted);margin-left:6px}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"addDropdown": `wjMCTTpJSakcsrOBJI1u`,
	"addButton": `qSRk8CLXNRM8Xt3qCdWF`,
	"addRightIcon": `ECPTxTYb0sMR6umYC8_b`
};
export default ___CSS_LOADER_EXPORT___;
